import { Koi } from '@ksyos/koi';
import { JournalEntryType } from '../enums/journalEntryType';
import { episode, episodeDraftAddSchema, episodeFinalAddSchema } from './episode';

interface IEpisode {
    codeCode: string | null;
    codeSystem: string | null;
    codeSystemName: string | null;
    comment: string | null;
    endDate: string | null;
    id: string;
    startDate: string | null;
    statusCode: string | null;
    valueDisplayName: string | null;
}
export interface IJournal {
    [JournalEntryType.Evaluatie]?: string;
    [JournalEntryType.Objectief]?: string;
    [JournalEntryType.Plan]?: string;
    [JournalEntryType.Subjectief]?: string;
    episodeValueDisplayName: string;
}

export interface IEpisodesAndJournals {
    episodes: IEpisode[];
    journalEntries: IJournal[];
}

export const journalEntrySchema = Koi.object({
    episodeValueDisplayName: Koi.string().optional().allow('', null),
    [JournalEntryType.Evaluatie]: Koi.string().max(255).optional().allow('', null),
    [JournalEntryType.Objectief]: Koi.string().max(255).optional().allow('', null),
    [JournalEntryType.Plan]: Koi.string().max(255).optional().allow('', null),
    [JournalEntryType.Subjectief]: Koi.string().max(255).optional().allow('', null),
});

export const episodesAndJournalEntriesSchema = Koi.object({
    episodes: Koi.array().items(episode),
    journalEntries: Koi.array().items(journalEntrySchema),
});

export const episodesAndJournalDraftAddEntriesSchema = Koi.object({
    episodes: Koi.array().items(episodeDraftAddSchema),
    journalEntries: Koi.array().items(journalEntrySchema),
});

export const episodesAndJournalFinalAddEntriesSchema = Koi.object({
    episodes: Koi.array().items(episodeFinalAddSchema),
    journalEntries: Koi.array().items(journalEntrySchema),
});

export const journalSchema = {
    schema: journalEntrySchema,
};
